<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>
    <md-card>
      <md-card-content>
        <div class="box">
          <div class="box-header">
            <h3 class="box-title">Air Export Details</h3>
          </div>
          <hr class="hr-s" />
          <!-- /.box-header -->
          <div class="box-body">
            <table id="conBooking" class="table table-bordered table-striped">
              <thead>
                <tr>
                  <!-- <th>Sr no</th> -->
                  <th>Assignment</th>

                  <th>More Details</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item1, index) in airFFData" :key="index">
                  <!-- <td>{{index+1}}</td> -->

                  <td
                    @click="
                      viewExportAirPage(
                        item1.airFcExportId,
                        item1.statusFinalExp
                      )
                    "
                    class="showMoreData"
                  >
                    <b>Assignment No. :</b>
                    {{ item1.airFFExportSeries }}
                    <br />
                    <b>Client :</b>
                    {{ item1.clientNameAll }}
                    <br />

                    <b>AirType :</b>
                    {{ item1.airFFType }}
                  </td>
                  <td>
                    <b>Departure Airport :</b>
                    {{ item1.departureAirport }}
                    <br />
                    <b>Destination Airport :</b>
                    {{ item1.destinationAirport }}
                    <br />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- /.box-body -->
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";

export default {
  beforeMount() {
    if (globalPermissionStatus("Client")) {
      this.$store.dispatch("setCurrentRoute", "/airFreight/viewAirFF");

      this.viewFFExportFCL();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },

  data() {
    return {
      isLoading: "",
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },

      airFFData: [],
    };
  },

  mounted() {},
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    // Loading
    CustomLoader,
  },

  computed: {},

  methods: {
    goToMain() {
      this.$sessionsStorage.set("editffAirExport", "");
      this.$router.push({
        path: "/airFreight/airFFExportConsol",
      });
    },
    JqueryFun() {
      return $(function () {
        return $("#conBooking").DataTable();
      });
    },

    viewExportAirPage(FCLAir, status) {
      this.$sessionsStorage.set("editffAirExport", FCLAir);
      let data = {
        jobType: "1",
        typeOf: "4",
        status: "",
        msgType: "1",
        allMessageId: FCLAir,
        statusMain: status,
      };

      this.$sessionsStorage.set("MessageStatus", JSON.stringify(data));
      //dasd

      this.$router.push({
        path: "/UpdateStatus/clientChatScreen",
      });
    },
    viewFFExportFCL() {
      this.isLoading = true;
      let payload = {
        view: "view",
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_ClientDashboard/viewFFAirExportList.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (data.AirExportDetails.length > 0) {
              this.airFFData = data.AirExportDetails;
            }
            this.isLoading = false;
            this.JqueryFun();
          }
        })
        .catch((error) => {});
    },
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// clientAirExport.vue?37f30c84